import React, { useEffect, useState } from 'react';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { withComponent } from 'js/components/hocs/withComponent';

import * as hooks from './hooks';
import * as Types from './types';

import style from './Balance.scss';

const BalanceBare: React.FC<{ type: Types.TBalanceType; args?: string }> = ({ type, args = '' }) => {
    const isMounted = useIsMounted();
    const getBalance = hooks.useGetBalance();
    const getCustomBalance = hooks.useGetCustomBalance();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const getTotalGoldenChipsBalance = hooks.useGetTotalGoldenChipsBalance();
    const [formattedBalance, setFormattedBalance] = useState<string | null>(null);

    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }

        if (type === 'balance_calc') {
            setFormattedBalance(getCustomBalance(args));

            return;
        }

        if (type === 'golden_chips_balance') {
            (async () => {
                try {
                    const goldenChipsBalance = await getTotalGoldenChipsBalance();

                    isMounted() && setFormattedBalance(goldenChipsBalance);
                } catch {
                    isMounted() && setFormattedBalance(null);
                }
            })();

            return;
        }

        setFormattedBalance(getBalance(type));

    }, [type, args, getBalance, getCustomBalance, getTotalGoldenChipsBalance, isMounted, isLoggedIn]);

    if (!isLoggedIn) {
        return null;
    }

    return formattedBalance
        ? (
            <span className={`${style.balance} cms-balance cms-balance-${type}`}>
                {formattedBalance}
            </span>
        )
        : null;
};

export const Balance = withComponent()(BalanceBare);

export default Balance;
